




















































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import EditLearningCourse from "./edit-learningCourse.vue";

class PageLearningCourseRequest extends PageRequest {
  keyword: string;
  ExternalType: number = 0;
  classTypeId: number = 11;
  GradeType: number = 1;
  multiTypeName: string = "高校课程";
  parentId?: number;
  parentName: string = "上级分类";
  categoryId?: number;
  cascaderContentType: number = 1;
  isAudit: boolean = true;
}

@Component({
  components: { EditLearningCourse },
})
export default class LearningCourses extends AbpBase {
  edit() {
    this.editModalShow = true;
  }
  //filters
  pagerequest: PageLearningCourseRequest = new PageLearningCourseRequest();
  editModalShow: boolean = false;
  multiTypes: any = [];
  data: any = [];
  showme: string = "测试";
  valueArray: any = [];

  searchGetpage() {
    this.$store.state.article.currentPage = 1;
    this.getpage();
  }
  cascaderSelect(value, selectedData) {
    if (value.length > 0) {
      this.pagerequest.categoryId = selectedData[selectedData.length - 1].value;
      this.pagerequest.parentName = selectedData[selectedData.length - 1].label;
    } else {
      this.pagerequest.categoryId = null;
    }
    this.searchGetpage();
  }
  handleRefresh() {
    this.loadCascaders();
    this.getpage();
  }
  get list() {
    return this.$store.state.learningCourse.list;
  }
  get loading() {
    return this.$store.state.learningCourse.loading;
  }
  create() {
    this.editModalShow = true;
    this.$store.state.learningCourse.editLearningCourse.classTypeId =
      this.pagerequest.classTypeId;
    this.$store.state.learningCourse.editLearningCourse.multiTypeName =
      this.pagerequest.multiTypeName;
    this.$store.state.learningCourse.editLearningCourse.parentId =
      this.pagerequest.parentId;
    this.$store.state.learningCourse.editLearningCourse.parentName =
      this.pagerequest.parentName;
  }
  selectChange(item) {
    this.pagerequest.classTypeId = item.id;
    this.pagerequest.multiTypeName = item.text;
    this.valueArray = [];
    this.pagerequest.parentId = null;
    this.loadCascaders();
    this.getpage();
  }
  pageChange(page: number) {
    this.$store.commit("learningCourse/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("learningCourse/setPageSize", pagesize);
    this.getpage();
  }
  async loadCascaders() {
    await this.$store
      .dispatch({
        type: "learningCourse/getCascader",
        data: this.pagerequest, //学习课程
      })
      .then((result) => {
        this.data = this.$store.state.learningCourse.cascaders.items;
        this.getpage();
      });
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "learningCourse/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.learningCourse.pageSize;
  }
  get totalCount() {
    return this.$store.state.learningCourse.totalCount;
  }
  get currentPage() {
    return this.$store.state.learningCourse.currentPage;
  }
  getTypeName(classTypeId) {
    for (var item of this.multiTypes) {
      if (item.id === classTypeId) return item.text;
    }
  }
  columns = [
    /**{
      title: "序号",
      width: 70,
      render: (h, params) => {
        return h(
          "span",
          {},
          (this.currentPage - 1) * this.pageSize + params.index + 1
        );
      },
    },
    */
    {
      title: "上级分类",
      width: 130,
      key: "parentName",
    },
    {
      title: "分类",
      width: 130,
      key: "categoryName",
    },
    {
      title: "标题",
      key: "title",
      render: (h, params) => {
        return h("span", [
          h(
            "A",
            {
              attrs: {
                target: "_blank",
                title: params.row.title,
                href: "http://www.sxjy.cq.cn/viewcs/" + params.row.id,
              },
              props: {
                type: "info",
                size: "small",
              },
              style: { "font-size": "12px", color: "#2c3e50" },
            },
            params.row.title
          ),
        ]);
      },
    },
    {
      title: "推荐",
      width: 65,
      render: (h: any, params: any) => {
        return h("span", params.row.isRecommend ? this.L("Yes") : this.L("No"));
      },
    },
    {
      title: "点击",
      width: 75,
      key: "clickVolume",
    },

    {
      title: "序号",
      width: 65,
      key: "sortNo",
    }, {
      title: "范围",
      width: 65,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              color: params.row.externalType > 0 ? (params.row.externalType == 1 ? '' : 'red') : '#2d8cf0'
            },
          },
          params.row.externalType > 0 ? (params.row.externalType == 1 ? '对外' : '对内') : '内外'
        );
      },

    },
    {
      title: this.L("CreationTime"),
      key: "creationTime",
      width: 100,
      render: (h: any, params: any) => {
        return h(
          "span",
          new Date(params.row.creationTime).toLocaleDateString()
        );
      },
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 140,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  this.$store
                    .dispatch({
                      type: "learningCourse/get",
                      data: params.row,
                    })
                    .then((result) => {
                      this.edit();
                    });
                },
              },
            },
            this.L("Edit")
          ),
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
                // disabled: params.row.id < 3,
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L(
                      "你确定要删除，第【" + (params.index + 1) + "】条记录吗？"
                    ),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "learningCourse/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete")
          ),
        ]);
      },
    },
  ];
  async created() {
    this.loadCascaders();
  }
}
